import { getAccessToken } from "@lib/shared/cookies";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";
import { ServerRequest, TextBlock } from "@lib/shared/types";

export interface GetTextBlocksPayload {
    categorySlug?: string | null | undefined;
    positions: string[];
}
export interface GetTextBlocksResponse {
    success: boolean;
    data: TextBlock[];
}
export const getTextBlocks = async (
    data: GetTextBlocksPayload,
    req?: ServerRequest,
): Promise<{ data: GetTextBlocksResponse | null; error: Error | null }> => {
    const isServer = !!req;
    const accessToken = isServer
        ? (req.accessToken as string)
        : (getAccessToken() as string);

    const config: AxiosRequestConfig = isServer
        ? {
              method: "get",
              url: `api/web/v1/text-blocks`,
              headers: {
                  Authorization: `Bearer ${accessToken}`,
                  "X-DOMAIN-NAME": `${req.headers.host ?? ""}`,
                  "X-Language": `${req.locale ?? "en"}`,
              },
              params: {
                  categorySlug: data.categorySlug,
                  positions: data.positions,
              },
          }
        : {
              method: "post",
              url: `/api/getTextBlocks`,
              headers: {
                  Authorization: `Bearer ${accessToken ?? ""}`,
              },
              data: {
                  ...data,
              },
          };

    const { data: textBlocksResponse, error } =
        await apiHandler<GetTextBlocksResponse>(() =>
            isServer ? HTTP.server(config) : HTTP.client(config),
        );

    return {
        data: textBlocksResponse ?? null,
        error,
    };
};
